import React, { Component } from 'react';
import {Field, FieldArray, reduxForm } from 'redux-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link, Redirect } from 'react-router-dom'
import _ from 'lodash';

import classes from '../../../utils/cssClasses';
import Loading from '../../Loading';
import Layout from '../Layout/Layout';
import { connect } from 'react-redux';
import * as actions from '../../../actions';

import style from './ImportAssertions.scss';

import RenderField from '../RenderField';
import EvidenceRepeater from '../EvidenceRepeater/EvidenceRepeater';
import ImportCsvDropzone from '../ImportCsvDropzone/ImportCsvDropzone';

import CsvToArray from './CsvToArray'
class ImportAssertion extends Component{
	
	constructor(props){
		super(props);

		this.state = {
			created: false,
			formLoading: false,
			assertions: []
		}
	}

	componentDidMount() {
		// this.props.fetchIssuer();
		this.props.fetchBadgeClass(this.props.match.params.id);
	}

	onSubmit(values) {
		if (values.expires){
			values.expires = new Date(values.expires);
		}
		this.props.importAssertions({
			assertion:values,
			assertions: this.state.assertions
		});
		this.setState({
			...this.state,
			formLoading: true
		})
		setTimeout( () => {
			this.setState({
				...this.state,
				created: true
			})
		},2000)
		
	}

	onFileDropped = ( filesToUpload, e ) => {
		console.log('input.validationTypes')
		const file = filesToUpload[0]
		var reader = new FileReader();
		reader.readAsText(file, "UTF-8");
		reader.onload = (evt) => {
			this.setState({

				assertions: CsvToArray(evt.target.result)
			});
		}
		reader.onerror = function (evt) {
			alert("error reading file");
		}
	}

	renderAssertionsList= () => {
		const {assertions} = this.state
		return (
			<div className={classes("mt-3")}>
				<h4>Assertions to create ({assertions.length}): </h4>
				<div className={classes("row import-list-header-row")}>
					<div className={classes("col-6")}>
						<b>Nome</b>
					</div>
					<div className={classes("col-6")}>
						<b>Mail</b>
					</div>
				</div>
				{ assertions.map( (assertion,i)  => (
					<div key={i} className={classes("row")}>
						<div className={classes("col-6")}>
							{assertion[0]}
						</div>
						<div className={classes("col-6")}>
							{assertion[1]}
						</div>
					</div>
				))}
			</div>
		)
	}


	render() {
		const { handleSubmit, badgeClass, assertion } = this.props;

		if (this.state.created){
			return (<Redirect to={`/admin/badgeclasses/${this.props.badgeClass._id}`} />);
		}
		if (this.state.formLoading){
			return (
				<Layout>
					<Loading />
				</Layout>
				);
		}

		if (badgeClass === null  || badgeClass._id !==  this.props.match.params.id ) {
			return (
				<Layout>
					<Loading />
				</Layout>
				);
		}else{

			return ( 
				<Layout>
					<header>
						<div className={classes('row align-items-center')}>
							<div className={classes('col-12 col-md')}>
								<h2>Assign BadgeClass <b>{badgeClass.name}</b></h2>
								<p><em>Assertions are representations of an awarded badge, used to share information about a badge belonging to one earner. </em></p>
							</div>
							<div className={classes('col-12 text-center text-md-right col-md-auto')}>
								<Link to={`/admin/badgeclasses/${badgeClass._id}`} className={classes('btn btn-primary btn-lg')}>
									Edit badge
								</Link>
							</div>
						</div>
						
						<div className={classes('row align-items-center')}>
							<div className={classes('col-auto image-head-view text-center',style)}>
								<img src={`/api/image/${badgeClass.image}`} alt=""/>
								<small>Badge image</small>
							</div>
							<div className={classes('col')}>
								<label>Import .csv file:</label>
								<ImportCsvDropzone
									onDropFile={this.onFileDropped}
									label="Drag here the .csv file, or click here to select it"
									name="image" />
								{this.state.assertions.length ? this.renderAssertionsList() : ''}
							</div>
						</div>
					</header>
					<form
						onSubmit={handleSubmit(this.onSubmit.bind(this))}>
						<Field
							name="badge"
							val={badgeClass._id}
							component={({ input, val }) => {
								input.onChange(val);
								return '';
							}} /> 
						<div className={classes('row mt-4')}>
							<div className={classes('col-12')}>
								<hr/>
								<h4>Evidences</h4>
								<p className={classes('mb-0 form-text text-muted')}>Field describing the work that the recipient did to earn the achievement. This can be a page that links out to other pages if linking directly to the work is infeasible.</p>
								<FieldArray
									name="evidence"
									component={EvidenceRepeater}
									/>
							</div>
							<div className={classes('col-12')}>
								<Field
									type="textarea"
									label="Narrative"
									name="narrative"
									component={RenderField} />
		        		
		        		<small>A narrative that connects multiple pieces of evidence. Likely only present at this location if evidence is more than one. <b>Can be written in markdwon</b> </small>
							</div>
							<div className={classes('col-12')}>
								<hr/>
							</div>
							<div className={classes('col-12 col-md-6')}>
								<Field
									type="date"
									label="Expire date"
									name="expires"
									component={RenderField} />
		        		
		        		<small>If the achievement has some notion of expiry, this indicates a timestamp when a badge should no longer be considered valid. After this time, the badge should be considered expired.</small>
							</div>
							<div className={classes('col-12 col-md-6')}>
								<Field
									type="checkbox"
									label="Revoked"
									id="revoked"
									name="revoked"
									component={RenderField} />		        		
		        		<small className={classes('mb-3')}>
		        			Defaults to false if Assertion is not referenced from a revokedAssertions list and may be omitted. See RevocationList. If revoked is true, only revoked and id are required properties, and many issuers strip a hosted Assertion down to only those properties when revoked.
		        		</small>
								<Field
									type="textarea"
									label="Revocation reason"
									name="revocationReason"
									component={RenderField} />
		        		<small>Optional published reason for revocation, if revoked.</small>
							</div>
							<div className={classes('col-12 mt-3')}>
								<button type="submit" className={classes('btn btn-primary btn-lg')} >Salva</button>
								{ this.props.badgeClass.loading ? (
	    							<FontAwesomeIcon icon="spinner" spin  />
									) : ''}
							</div>
						</div>
					</form>
				</Layout>
			);
		}
	}
}

function mapStateToProps( { assertion, badgeClass } ){
	// console.log(issuer)
	return {
		badgeClass,
		assertion
		// initialValues: badgeClass
	};
}

function validate(values){
	const errors = {};
	//validate inputs
	const requireds = ["email"];
	
	_.forEach(requireds,(key) => {
		if (! values[key]){
			errors[key] = "Mandatory field";
		}
	})

	return errors;
}

export default connect(mapStateToProps,actions)(reduxForm({
	validate,
  enableReinitialize: true, 
	form: 'CreateAssertion'
})(ImportAssertion));


// WEBPACK FOOTER //
// ./src/components/Backend/ImportAssertions/ImportAssertions.js